import React from "react";
import { StyledButton, StyledSwipeableDrawer } from "../../../../../../styled-mui";
import MobileMenuWrapper from "../../MobileMenuWrapper";
import { Box } from "@mui/material";
import { CLICK } from "../../../../../../_foundation/constants/gtm";
import AsyncCall from "../../../../../../_foundation/gtm/async.service";
import SmartLink from "../../../../../elements/smart-link/smart-link";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router";

interface Props {
  open: boolean;
  entireMenuCloseHandler: () => any;
  closeCurrentMenu: () => any;
  levelOneCat: Record<string, any> | null;
  levelTwoCat: Record<string, any> | null;
  filteredLinksByCatL1: Record<string, any>[];
}

const blueButtonStyles: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  columnGap: "8px",
  fontSize: "15px",
  fontWeight: "500",
  lineHeight: "15px",
  textTransform: "none",
  color: "rgba(93, 137, 162, 1)",
  padding: "10px 0px",
  marginBottom: "12px",
};

const MobileProductsLevel3Menu: React.FC<Props> = ({
  open,
  entireMenuCloseHandler,
  closeCurrentMenu,
  levelOneCat,
  levelTwoCat,
  filteredLinksByCatL1,
}) => {
  const navigate = useNavigate();
  const levelThreeCategoryChildren = levelTwoCat?.children || [];

  const onCatItemClick = (catItem: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      navlink: catItem?.name + "_" + catItem?.seo?.href,
    });
    entireMenuCloseHandler();
  };

  const onUniverseBtnClick = () => {
    entireMenuCloseHandler();
    navigate(levelOneCat?.seo?.href);
  };

  const onViewOtherProductsClick = () => {
    entireMenuCloseHandler();
    navigate(levelTwoCat?.seo?.href);
  };

  return (
    <StyledSwipeableDrawer
      anchor="left"
      open={open}
      onClose={closeCurrentMenu}
      onOpen={() => null}
      className="child-drawer header-menu-level4 mobile-produits-level3-menu">
      <MobileMenuWrapper
        title={levelTwoCat?.name || ""}
        isASubMenu
        entireMenuCloseHandler={entireMenuCloseHandler}
        closeCurrentMenu={closeCurrentMenu}>
        <Box p={3}>
          <Box mb="40px">
            {levelThreeCategoryChildren.map((catItem: Record<string, any>, index: number) => (
              <SmartLink
                key={catItem?.identifier}
                onClick={() => onCatItemClick(catItem)}
                to={catItem?.seo?.href || ""}
                styles={{
                  display: "block",
                  fontWeight: "500",
                  fontSize: "16px",
                  lineHeight: "100%",
                  padding: "12px 0px",
                }}>
                {catItem?.name}
              </SmartLink>
            ))}
          </Box>
          <StyledButton variant="text" onClick={onViewOtherProductsClick} sx={blueButtonStyles}>
            Voir les autres produits
            <ArrowForwardIcon sx={{ width: 20 }} />
          </StyledButton>

          {filteredLinksByCatL1.map((linkItem: Record<string, any>, index: number) => (
            <SmartLink
              key={linkItem?.label + index}
              to={linkItem?.url}
              isExternal={linkItem?.type === "external"}
              target={linkItem?.target}
              onClick={() => entireMenuCloseHandler()}
              styles={blueButtonStyles}>
              {linkItem?.label || ""}
              <ArrowForwardIcon sx={{ width: 20 }} />
            </SmartLink>
          ))}

          <StyledButton
            variant="text"
            onClick={onUniverseBtnClick}
            sx={{ ...blueButtonStyles, color: "rgba(37, 36, 39, 1)", fontWeight: 700 }}>
            Découvrir l'univers
            <ArrowForwardIcon sx={{ width: 20 }} />
          </StyledButton>
        </Box>
      </MobileMenuWrapper>
    </StyledSwipeableDrawer>
  );
};

export default MobileProductsLevel3Menu;
